module.exports = __webpack_public_path__ + "img/absolut-logo.a8d56c17.svg";